export default "__VITE_ASSET__BHrwe04e__"